const messages = {
  title: "Domov",
  welcomeMessage:
    'Dobrodošli v BRIDGESTONE <span class="text-danger">PLUS</span>, %{first_name} %{last_name}',
  home: "Domov",
  search: "Iskanje",
  sortBy: "Razvrsti po",
  seeMore: "Poglej več",
  bankstatement: {
    yourScore: "Vaše trenutno število marketinških točk:",
    lastUpdate: "Zadnja posodobitev:",
    link: "Pregled stanja točk",
  },
  shop: {
    bestSold: "Najbolj prodano",
    seasonal: "Sezonsko",
    affordable: "Dostopno",
    forPoints: "za {points} točk",
    reachedPoints: "Zahtevane točke dosežene",
    cartRemainPoints: "Preostale točke",
    remainingPoints: "{points} preostalih točk",
    noProducts: "Kriteriji iskanja niso dali rezultatov",
    variant: "Različice na izbiro",
  },
  showAllProducts: "Pojdi v trgovino",
  shopClosedBanner:
    "<div>BRIDGESTONE <span class='text-danger'>PLUS</span> SHOP</div><div>bo kmalu spet na voljo.</div>",
};

export default {
  messages,
};
